// extracted by mini-css-extract-plugin
module.exports = {"container":"point-tag-module__container___rtLAV","tag":"point-tag-module__tag___CWYMA","star":"point-tag-module__star___P4mnl","available":"point-tag-module__available___7IPdK"};